import { IQueryParams } from 'src/types';

export const removeEmpty = (obj: IQueryParams): IQueryParams => {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null && v !== ''));
};
